import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PublicPage } from "@/components/landing/PublicPage";
import { BoardCard } from "@/components/landing/BoardSection";

export default function Pengurus() {
  const [board, setBoard] = useState(null);
  useEffect(() => {
    api.get("/board").then((r) => setBoard(r.data)).catch(() => setBoard([]));
  }, []);

  return (
    <PublicPage testId="pengurus-page" eyebrow="Struktur Organisasi" title="Pengurus DKM Al-Iman" desc="Dewan Kemakmuran Masjid yang mengemban amanah jamaah dalam mengelola ibadah, kegiatan, dan keuangan masjid. Hubungi pengurus melalui kontak yang tersedia.">
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
        {board?.map((p, i) => <BoardCard key={p.id} p={p} featured={i === 0} showContact />)}
      </div>
      {board?.length === 0 && <p className="rounded-3xl border border-dashed border-emerald-900/20 p-12 text-center text-slate-500" data-testid="pengurus-empty">Data pengurus belum tersedia.</p>}
    </PublicPage>
  );
}
